import { MaterialCommunityIcons } from '@expo/vector-icons';
import { COLORS } from '../../../config/designSystem/Colors';
import { ParagraphSBold } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { StyleSheet, TouchableOpacity } from 'react-native';

interface NewScanButtonProps {
  label: string;
  onPress: () => void;
}

export const NewScanButton = ({ label, onPress }: NewScanButtonProps) => {
  return (
    <TouchableOpacity
      style={styles.button}
      onPress={onPress}
      activeOpacity={0.85}
    >
      <MaterialCommunityIcons name="face-recognition" size={20} color={COLORS.gray[0]} />
      <ParagraphSBold color={COLORS.gray[0]}>{label}</ParagraphSBold>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    position: 'absolute',
    bottom: SPACING['sp-24'],
    right: SPACING['sp-24'],
    flexDirection: 'row',
    alignItems: 'center',
    gap: SPACING['sp-8'],
    backgroundColor: COLORS.brand[500],
    paddingVertical: SPACING['sp-12'],
    paddingHorizontal: SPACING['sp-20'],
    borderRadius: SPACING['sp-24'],
    // @ts-ignore - web-only property
    boxShadow: `0 4px 12px ${COLORS.brand[800]}4D`,
    // @ts-ignore - web-only property
    cursor: 'pointer',
  },
});
